// src/utils/ApiError.ts

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;

    // Set the prototype explicitly (for instanceof to work in transpiled code)
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}